/**
 * The plan page's line for a chosen plan whose figures are out of date (owner, 25 Oct 2026: the village, downsizing,
 * the granny flat and cashflow say so as aged care and Support at home do). Aged care's idiom: a white panel with a
 * slate outline and an amber rail (no pastel fill), the reason in plain words, and a way to choose again.
 */
import React from 'react';

interface Props {
    reason: string | null;
    /** When the plan was chosen, in words ("24 Oct 2026"), or null. */
    chosenOn?: string | null;
    onChooseAgain: () => void;
    testId?: string;
}

export function PlanOutOfDateBanner({ reason, chosenOn = null, onChooseAgain, testId = 'plan-out-of-date' }: Props) {
    if (!reason) return null;
    return (
        <div className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 border-l-4 border-l-amber-400 bg-white px-4 py-3 text-[14px] text-slate-700" data-testid={testId}>
            <p><strong className="text-slate-900">{reason.replace(/ — open it to choose again\.$/, '.')}</strong> The figures below are the ones it was chosen on{chosenOn ? `, ${chosenOn}` : ''}.</p>
            <button type="button" onClick={onChooseAgain} className="rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-[13px] font-semibold text-slate-800 hover:border-blue-300">Choose a plan again</button>
        </div>
    );
}
